import React from 'react';
import '../premium-1/premium-1.scss';
import Navbar from './premium-1-component/Navbar';
import Header from './premium-1-component/Header';
import Gallery from './premium-1-component/Gallery';
import Parallax from './premium-1-component/Parallax';
import ExpertiseSection from './premium-1-component/ExpertiseSection';
import Skills from './premium-1-component/Skills';
import Services from './premium-1-component/Services';
import Testimonial from './premium-1-component/Testimonial';
import Contact from './premium-1-component/Contact';
import InstagramCarousel from './premium-1-component/InstagramCarousel';
import ScrollToTop from './premium-1-component/ScrollToTop';
import Footer from './premium-1-component/Footer';


const Premium1 = () => {
  
  return (
    <div id="premium-1">

      < Navbar />

      <Header />

      <Gallery />

      <Parallax />

      <ExpertiseSection />

      <Skills />

      <Services />

      <Testimonial />

      <Contact />

      <InstagramCarousel />

      <ScrollToTop />

      <Footer />

    </div>
  );
};

export default Premium1;
  